<!--
 * @Description: 交叉分析表与卡方分析
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt" style="margin-top: -30px">
    <div>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="190" :itemWidth="420 + 56">
      <div
        style="text-align: center"
        v-for="(item, index) in TYPE_MAPPING"
        :key="index"
      >
        <BaseCard style="width: 420px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            :value="item.value"
            :model-value="curItem.value"
            @click="onChange(item.value)"
            style="height: 130px !important"
          >
            <div
              style="
                width: 1200px;
                transform: scale(0.32);
                transform-origin: center 0;
                white-space: wrap;
              "
            >
              <component
                :is="cmpName(item.value)"
                v-bind="{
                  tableHeaderList: [
                    {
                      prop: 'header',
                      label: [`卡方分析结果`],
                      subHeaderList: [
                        {
                          ...analysis[0].chiSquareTable.header[0],
                          group: true
                        },
                        analysis[0].chiSquareTable.header[1],
                        {
                          prop: '_title',
                          label: [analysis[0].chiSquareTable.title],
                          subHeaderList:
                            analysis[0].chiSquareTable.header.slice(
                              2,
                              analysis[0].chiSquareTable.header.length - 3
                            )
                        },
                        analysis[0].chiSquareTable.header.slice(-3, -2)[0],
                        {
                          ...analysis[0].chiSquareTable.header.slice(-2, -1)[0],
                          group: true
                        },
                        {
                          ...analysis[0].chiSquareTable.header.slice(-1)[0],
                          group: true
                        }
                      ]
                    }
                  ],
                  tableDataList: analysis[0].chiSquareTable.value.map(
                    (item, index, arr) =>
                      arr.length - 1 == index
                        ? item
                        : {
                            ...item,
                            headerTit: [
                              ...analysis[0].chiSquareTable.value[0].headerTit
                            ],
                            headerX2: [
                              ...analysis[0].chiSquareTable.value.slice(
                                -2,
                                -1
                              )[0].headerX2
                            ],
                            headerP: [
                              ...analysis[0].chiSquareTable.value.slice(
                                -2,
                                -1
                              )[0].headerP
                            ]
                          }
                  )
                }"
              />
            </div>
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
    <div
      style="
        padding: 10px 24px;
        font-size: 14px;
        border: 1px solid #dbdbdb;
        margin-top: 16px;
      "
    >
      <div style="width: 100%; text-align: center; margin: 5px 0">分析结论</div>
      <div v-html="analysis[0].resultSystem"></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import PcModuleChiSquareAnalysis from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-chi-square-analysis';

import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { BaseCard } from 'xrk-components';
import { analysis } from '../../../../mock/_analysis';

const CHILD_KEY = '6_3';

const TYPE_MAPPING = {
  1: {
    value: 'pc-module-chi-square-analysis-1',
    moduleType: 'pc-module-chi-square-analysis-1'
  },
  2: {
    value: 'pc-module-chi-square-analysis-2',
    moduleType: 'pc-module-chi-square-analysis-2'
  },
  3: {
    value: 'pc-module-chi-square-analysis-3',
    moduleType: 'pc-module-chi-square-analysis-3'
  },
  4: {
    value: 'pc-module-chi-square-analysis-4',
    moduleType: 'pc-module-chi-square-analysis-4'
  },
  5: {
    value: 'pc-module-chi-square-analysis-5',
    moduleType: 'pc-module-chi-square-analysis-5'
  },
  6: {
    value: 'pc-module-chi-square-analysis-6',
    moduleType: 'pc-module-chi-square-analysis-6'
  }
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
const cmpName = name => {
  return PcModuleChiSquareAnalysis.filter(comp => comp.__name === name)[0];
};
</script>
